import { getLocalToken } from "../services/authorizationService"
import { logout } from "../services/authorizationService";
import { showError } from "../services/toastServices";
import axios from 'axios';

export const URL = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BASE_API_URL
    : process.env.REACT_APP_BASE_API_URL

export const createAxiosInstance = ((controllerName)=>{
    const token = getLocalToken()
    const axiosApiInstance = axios.create({
        baseURL: `${URL}/${controllerName}`,
        headers: {'Authorization':`bearer ${token}`}
    });
    // axiosApiInstance.interceptors.request.use(function (config) {
    //     const token = getLocalToken();
    //     config.headers.Authorization =  token ? `Bearer ${token}` : '';
    //     return config;
    // });    
    axiosApiInstance.interceptors.response.use((response) => {
        return response
      }, async function (error) {
        if(!error.response){
            showError('Error conexión')
        }else{
            const originalRequest = error.config;
            if (error.response.status === 401 || error.response.status === 403) {
                logout();
                window.location.href = "/login";
                return axiosApiInstance(originalRequest);
            }
        }
        return Promise.reject(error);
    });
    return axiosApiInstance;

})

